import { DetailLoading, DetailNotFound } from "../components/DetailStates";
import { useItemDetail } from "./item-detail/useItemDetail";
import { ItemDetailView } from "./item-detail/ItemDetailView";

export default function ItemDetail() {
  const model = useItemDetail();
  if (model.status === "loading") return <DetailLoading label={model.label} />;
  if (model.status === "notfound") return <DetailNotFound title={model.title} backHref="/marketplace?tab=Materials" backLabel={model.backLabel} />;
  return <ItemDetailView model={model} />;
}
